import React from "react";
import { FiArrowRight, FiChevronDown } from "react-icons/fi";
import {
  HeroActions,
  HeroContainer,
  HeroContent,
  HeroEyebrow,
  HeroImage,
  HeroOverlay,
  HeroSubtitle,
  HeroTitle,
  ScrollCue,
} from "./HomeHeaderElements";
import { ButtonLink } from "../../general/Button";
import { useLanguage } from "../../../contexts";
import { scrollBehavior } from "../../../utils";

export const HOME_CONTENT_ID = "home-content";

const HomeHeader = () => {
  const { t } = useLanguage();

  const scrollToContent = () => {
    document
      .getElementById(HOME_CONTENT_ID)
      ?.scrollIntoView({ behavior: scrollBehavior() });
  };

  return (
    <HeroContainer>
      <HeroImage alt="" src={require("../../../assets/images/home.JPG")} />
      <HeroOverlay />
      <HeroContent>
        <HeroEyebrow $light>{t("HOME.HEADER.EYEBROW")}</HeroEyebrow>
        <HeroTitle>{t("HOME.HEADER.TITLE")}</HeroTitle>
        <HeroSubtitle>{t("HOME.HEADER.SUBTITLE")}</HeroSubtitle>
        <HeroActions>
          <ButtonLink to="/products">
            {t("HOME.OUR_PRODUCTS")}
            <FiArrowRight />
          </ButtonLink>
          <ButtonLink to="/about" $variant="ghost">
            {t("HOME.OUR_STORY")}
          </ButtonLink>
        </HeroActions>
      </HeroContent>
      <ScrollCue
        type="button"
        onClick={scrollToContent}
        aria-label={t("HOME.SCROLL")}
      >
        <FiChevronDown />
      </ScrollCue>
    </HeroContainer>
  );
};

export default HomeHeader;
